import { Users, Star, Trash2, UserMinus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import type { Group, Participant } from '../../types';

interface GroupCardProps {
  group: Group;
  participants: Participant[];
  onDelete: () => void;
  onRemoveParticipant: (participantId: string) => void;
  onSetRepresentative: (participantId: string) => void;
}

export function GroupCard({
  group,
  participants,
  onDelete,
  onRemoveParticipant,
  onSetRepresentative,
}: GroupCardProps) {
  const groupParticipants = participants.filter((p) => group.participantIds.includes(p.id));

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <Users className="h-4 w-4" />
            {group.name}
          </CardTitle>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-muted-foreground hover:text-destructive"
            onClick={onDelete}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        {groupParticipants.length === 0 ? (
          <p className="text-sm text-muted-foreground">Sin miembros</p>
        ) : (
          <ul className="space-y-1">
            {groupParticipants.map((participant) => (
              <li
                key={participant.id}
                className="flex items-center justify-between py-1.5 px-2 rounded-md hover:bg-accent/50"
              >
                <div className="flex items-center gap-2">
                  <span className="text-sm">{participant.name}</span>
                  {participant.id === group.representativeId && (
                    <Star className="h-3.5 w-3.5 text-yellow-500 fill-yellow-500" />
                  )}
                </div>
                <div className="flex items-center gap-1">
                  {participant.id !== group.representativeId && (
                    <Button
                      variant="ghost"
                      size="icon"
                      className="h-7 w-7"
                      onClick={() => onSetRepresentative(participant.id)}
                      title="Hacer representante"
                    >
                      <Star className="h-3.5 w-3.5" />
                    </Button>
                  )}
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-7 w-7 text-muted-foreground hover:text-destructive"
                    onClick={() => onRemoveParticipant(participant.id)}
                    title="Quitar del grupo"
                  >
                    <UserMinus className="h-3.5 w-3.5" />
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
